import { course_audiences, course_categories, course_statuses, department_cards, matrix_cards, matrix_rows, refreshers_cards, refresher_department_routes, refresher_rows, reminders_cards, reminders_rows, results_rows, tabs, training_departments, training_record_statuses, training_result_options } from './training_program_data';
import { course_drawers } from './training_program_drawers';
import { compute_results_cards, default_course_form, default_result_form, normalise_course_drawer, normalise_department_card, normalise_training_result, normalise_training_row } from './training_program_helpers';
import { training_program_methods } from './training_program_ui';

const normalised_matrix_rows = matrix_rows.map(normalise_training_row);
const normalised_results_rows = results_rows.map(normalise_training_result);
const normalised_department_cards = department_cards.map(normalise_department_card);
const normalised_course_drawers = Object.fromEntries(Object.entries(course_drawers).map(([key, drawer]) => [key, normalise_course_drawer(drawer)]));

export default {
  name: 'ComplyonTraining',
  data: () => ({
    tabs,
    active_tab: 'matrix',
    matrix_cards,
    matrix_rows: [...normalised_matrix_rows],
    results_cards: compute_results_cards(normalised_results_rows),
    results_rows: [...normalised_results_rows],
    refreshers_cards,
    refresher_rows,
    reminders_cards,
    reminders_rows,
    department_cards: normalised_department_cards,
    course_categories,
    course_audiences,
    course_statuses,
    training_departments,
    training_result_options,
    training_record_statuses,
    refresher_department_routes,
    course_drawers: { ...normalised_course_drawers },
    show_course_modal: false,
    show_result_modal: false,
    result_modal_mode: 'create',
    editing_result_index: null,
    course_form: default_course_form(),
    result_form: default_result_form(),
    active_course_drawer: null
  }),
  methods: training_program_methods
};
